import { HTTP } from '../http-common.js';

class AuthService {
  login(email, password) {
    return HTTP.post('/users/authenticate', {
      email: email,
      password: password,
    }).then((response) => {
      if (response.data.token) {
        localStorage.setItem('user', JSON.stringify(response.data));
      }

      return response.data;
    });
  }

  register(firstname, lastname, email, municipalityCode) {
    return HTTP.post('/users/register', {
      firstname: firstname,
      lastname: lastname,
      email: email,
      municipalityCode: municipalityCode,
    });
  }

  resetPassword(token, password) {
    return HTTP.post('/users/reset', {
      token: token,
      password: password,
    }).then((response) => {
      localStorage.removeItem('user');

      return response.data;
    });
  }

  forgot(email) {
    return HTTP.post('/users/forgot', {
      email: email,
    }).then((response) => {
      localStorage.removeItem('user');

      return response.data;
    });
  }

  logout() {
    localStorage.removeItem('user');
  }
}

export default new AuthService();
